import React from "react";

class IconReload extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width}
        height={this.props.height}
        fill="none"
        viewBox="0 0 28 29"
        style={this.props.style}
      >
        <g clipPath="url(#clip0_10183_57805)">
          <path
            fill="#fff"
            d="M19.465 5.28c-.07-.4-.11-.739-.18-1.077-.15-.82.27-1.518 1.02-1.682.72-.154 1.381.328 1.522 1.159.27 1.507.53 3.025.77 4.543.13.82-.35 1.457-1.14 1.59-1.482.256-2.963.513-4.435.78-.71.123-1.351-.319-1.511-1.057-.15-.677.28-1.364.97-1.538.281-.072.581-.113.872-.165.28-.05.55-.092.89-.153a7.558 7.558 0 00-2.182-.913c-4.754-1.2-9.538 2.03-10.339 6.974-.75 4.636 2.202 9.015 6.716 9.949 4.574.944 9.128-2.226 9.93-6.923.02-.133.04-.267.07-.4.16-.646.78-1.108 1.38-1.016.731.103 1.252.667 1.162 1.385-.11.78-.25 1.57-.531 2.297-1.521 4.021-4.344 6.523-8.498 7.293-5.915 1.097-11.55-2.872-12.741-8.893-1.151-5.897 2.372-11.702 8.057-13.21 2.732-.718 5.375-.42 7.887.903.08.04.16.082.31.154z"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_10183_57805">
            <path
              fill="#fff"
              d="M0 0H22V24H0z"
              transform="translate(3 2.5)"
            ></path>
          </clipPath>
        </defs>
      </svg>
    );
  }
}

IconReload.defaultProps = {
    width: 28,
    height: 29
}

export default IconReload;
